import { render, staticRenderFns } from "./OrderableBox.vue?vue&type=template&id=054b4afa"
import script from "./OrderableBox.vue?vue&type=script&lang=js"
export * from "./OrderableBox.vue?vue&type=script&lang=js"
import style0 from "./OrderableBox.vue?vue&type=style&index=0&id=054b4afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports